// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { taikoJolnir as _taikoJolnir } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the taikoJolnir chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 167007
 * Chain Name: Taiko Jolnir (Alpha-5 Testnet)
 * Default Block Explorer: https://explorer.jolnir.taiko.xyz
 * Default RPC URL: https://rpc.jolnir.taiko.xyz
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { taikoJolnir } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: taikoJolnir,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const taikoJolnir = createCommon({
	..._taikoJolnir,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
